import { GenericStatusColorType } from './interfaces/generic-status';

export const STATUS_COLOR_MAP: { [key in GenericStatusColorType]: string } = {
  [GenericStatusColorType.SUCCESS]: 'success',
  [GenericStatusColorType.INFO]: 'info',
  [GenericStatusColorType.ERROR]: 'error',
  [GenericStatusColorType.WARNING]: 'warning',
  [GenericStatusColorType.DEFAULT]: 'default',
  [GenericStatusColorType.DISABLED]: 'disabled'
};

export const COMING_SOON_DESCRIPTION = 'This feature is under development';

export const RBAC_DEFAULT_DISABLED_MESSAGE =
  'Unable to perform the fetch to check if the action is disabled, please refresh the page';
